module.exports = __webpack_public_path__ + "static/media/steve_jobs.dab6e49b.jpg";